var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImageMembershipSvipMain(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 63,
    viewBox: "0 0 62 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1618_59810)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.6876 2.02998L21.4286 9.08012C20.8687 9.62389 20.119 9.92806 19.3385 9.92806H12.4444C10.7876 9.92806 9.44444 11.2712 9.44444 12.9281V20.2664C9.44444 21.1053 9.09313 21.906 8.47574 22.474L3.33533 27.2038C2.06734 28.3705 2.04045 30.363 3.27649 31.5635L9.33522 37.4479C9.96825 38.0627 10.2985 38.925 10.2381 39.8054L9.66447 48.1615C9.54547 49.8951 10.9197 51.3669 12.6574 51.3669H21.0712C21.8784 51.3669 22.6515 51.6922 23.2159 52.2692L28.7378 57.9144C29.8735 59.0755 31.7271 59.1219 32.9195 58.019L39.2487 52.1646C39.8032 51.6518 40.5306 51.3669 41.2858 51.3669H50C51.6569 51.3669 53 50.0238 53 48.3669V39.5518C53 38.8207 53.267 38.1148 53.7507 37.5667L59.1074 31.497C60.167 30.2964 60.0969 28.4754 58.9483 27.3598L53.9099 22.4664C53.3282 21.9015 53 21.1252 53 20.3144V12.9281C53 11.2712 51.6569 9.92806 50 9.92806H42.2171C41.4366 9.92806 40.6868 9.62389 40.1269 9.08012L32.8679 2.02998C31.7038 0.899394 29.8517 0.899396 28.6876 2.02998Z",
    fill: "url(#paint0_linear_1618_59810)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.12 34.14C24.82 34.14 25.83 33.11 25.83 31.9C25.83 30.84 25.24 30.26 24.35 29.89L23.38 29.49C22.75 29.24 22.22 29.04 22.22 28.51C22.22 28.03 22.63 27.74 23.28 27.74C23.89 27.74 24.38 27.96 24.86 28.35L25.6 27.42C25 26.81 24.14 26.47 23.28 26.47C21.79 26.47 20.72 27.4 20.72 28.61C20.72 29.68 21.48 30.29 22.22 30.59L23.21 31.01C23.87 31.29 24.32 31.47 24.32 32.02C24.32 32.53 23.92 32.86 23.15 32.86C22.5 32.86 21.79 32.54 21.27 32.05L20.42 33.07C21.14 33.76 22.12 34.14 23.12 34.14ZM28.4502 34H30.2102L32.4802 26.6H30.9702L30.0102 30.2C29.7902 31.03 29.6302 31.76 29.3902 32.6H29.3402C29.1102 31.76 28.9402 31.03 28.7102 30.2L27.7402 26.6H26.1802L28.4502 34ZM33.3416 34H34.8216V26.6H33.3416V34ZM36.6424 34H38.1224V31.37H39.1124C40.7024 31.37 41.9624 30.62 41.9624 28.93C41.9624 27.17 40.7024 26.6 39.0724 26.6H36.6424V34ZM38.1224 30.2V27.78H38.9624C39.9824 27.78 40.5224 28.06 40.5224 28.93C40.5224 29.77 40.0324 30.2 39.0124 30.2H38.1224Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1618_59810",
    x: 0.366211,
    y: 1.18204,
    width: 61.4922,
    height: 61.6346,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1618_59810"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1618_59810",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1618_59810",
    x1: 9,
    y1: 8.5,
    x2: 53,
    y2: 51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5624"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8718"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageMembershipSvipMain);
export default __webpack_public_path__ + "static/media/image__membership-svip--main.cc940e03668c16fe57899e259e561e1a.svg";
export { ForwardRef as ReactComponent };